import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bookingExpired',
})
export class BookingExpiredPipe implements PipeTransform {
  transform(bookingDeadline: string | Date | null | undefined): boolean {
    if (!bookingDeadline) return false;
    const deadline = new Date(bookingDeadline).getTime();
    const today = new Date().getTime();

    return deadline < today;
  }
}
//restituisce true se supera la data ultima di prenotazione
